module.exports = __webpack_public_path__ + "img/Icon-Refresh.5b560831.svg";